import { isCrmDocketLead } from "../Pages/Agent/Crm/crmLeadFormatters";

const CRM_HANDOFF_STORAGE_KEY = "crm_lead_offer_handoff";

/**
 * Persist CRM lead context for offer creation across tabs (localStorage + URL).
 */
export function startCrmLeadOfferHandoff(navigate, lead) {
  const leadId = String(lead?.id || "").trim();
  if (!leadId) return;

  const returnTab = isCrmDocketLead(lead) ? "dockets" : "leads";
  const payload = {
    crmLeadId: leadId,
    full_name: lead?.full_name || "",
    phone: lead?.phone || "",
    email: lead?.email || "",
    interest_destination: lead?.interest_destination || "",
    returnTab,
    savedAt: Date.now(),
  };

  try {
    localStorage.setItem(CRM_HANDOFF_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
  try {
    sessionStorage.setItem(CRM_HANDOFF_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }

  const params = new URLSearchParams();
  params.set("crmLeadId", leadId);
  params.set("crmReturnTab", returnTab);
  if (payload.full_name) params.set("crmLeadName", payload.full_name);
  if (payload.phone) params.set("crmLeadPhone", payload.phone);
  if (payload.email) params.set("crmLeadEmail", payload.email);
  if (payload.interest_destination) {
    params.set("crmLeadDest", payload.interest_destination);
  }

  const path = `/p/dashboard/searchoffer?${params.toString()}`;
  const opened = window.open(path, "hotelsriver_crm_offer_search");
  if (!opened) {
    // Popup blocked — stay in-app
    if (typeof navigate === "function") {
      navigate(path);
    } else {
      window.location.assign(path);
    }
  }
}

export function readCrmLeadOfferHandoff() {
  const tryParse = (raw) => {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      if (!parsed?.crmLeadId) return null;
      return parsed;
    } catch {
      return null;
    }
  };
  try {
    const fromLocal = tryParse(localStorage.getItem(CRM_HANDOFF_STORAGE_KEY));
    if (fromLocal) return fromLocal;
  } catch {
    // ignore
  }
  try {
    return tryParse(sessionStorage.getItem(CRM_HANDOFF_STORAGE_KEY));
  } catch {
    return null;
  }
}

/** Resolve handoff from URL search params and/or storage. */
export function resolveCrmLeadOfferHandoff(searchParams) {
  const fromUrlId = String(
    searchParams?.get?.("crmLeadId") || ""
  ).trim();
  if (fromUrlId) {
    return {
      crmLeadId: fromUrlId,
      full_name: String(searchParams.get("crmLeadName") || "").trim(),
      phone: String(searchParams.get("crmLeadPhone") || "").trim(),
      email: String(searchParams.get("crmLeadEmail") || "").trim(),
      interest_destination: String(
        searchParams.get("crmLeadDest") || ""
      ).trim(),
      returnTab: String(searchParams.get("crmReturnTab") || "leads").trim() || "leads",
      fromUrl: true,
    };
  }
  return readCrmLeadOfferHandoff();
}

export function clearCrmLeadOfferHandoff() {
  try {
    localStorage.removeItem(CRM_HANDOFF_STORAGE_KEY);
  } catch {
    // ignore
  }
  try {
    sessionStorage.removeItem(CRM_HANDOFF_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export { CRM_HANDOFF_STORAGE_KEY };
